import { Flex, Image, useBreakpointValue } from "@chakra-ui/react";
import { ReactNode } from "react";

import { OFText } from "design_system/components/OFText";
import { colors } from "src/colors";

export type StartedCardProps = {
  index: number;
  title: string;
  srcImage: string;
  description: string;
  subTitle?: ReactNode;
  highlight?: boolean;
  showDashLine?: boolean;
};
export const GetStartedCard = ({
  srcImage,
  title,
  subTitle,
  description,
  index,
  highlight,
  showDashLine = true
}: StartedCardProps) => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const textColor = highlight ? colors.white.default : colors.black["900"];
  const bgColor = highlight ? colors.orange["400"] : colors.white.default;
  return (
    <Flex
      flexDirection="column"
      position="relative"
      pb={["24px", "32px"]}
      pl={["40px", "56px"]}
      {...(showDashLine && {
        _before: {
          position: "absolute",
          content: '""',
          display: "flex",
          left: isMobile ? "16px" : "28px",
          top: 0,
          height: "100%",
          width: "1px",
          borderWidth: "1px",
          background: "red",
          borderStyle: "dashed"
        }
      })}
    >
      <Flex flexDirection="column" background={bgColor} padding={["12px", "20px"]}>
        <Flex>
          <Flex
            position="absolute"
            top="0"
            zIndex={1}
            left={isMobile ? 0 : "8.5px"}
            width={["32px", "40px"]}
            height={["32px", "40px"]}
            justifyContent="center"
            alignItems="center"
            border={`solid 1px ${colors.orange["400"]}`}
            borderRadius="50%"
            backgroundColor={bgColor}
          >
            <OFText
              textStyle="body1semibold"
              color={highlight ? colors.white.default : colors.orange["400"]}
            >
              {index}
            </OFText>
          </Flex>
          <Image
            borderRadius="8px"
            src={srcImage}
            width={["100px", "160px"]}
            height={["100px", "160px"]}
          />
          <Flex flexDirection="column" marginLeft={["12px", "11.5px"]}>
            <OFText color={textColor} textStyle="h5">
              {title}
            </OFText>
            {subTitle}
            {!isMobile && (
              <OFText textStyle="body2" color={textColor} marginTop={["9px", "13px"]}>
                {description}
              </OFText>
            )}
          </Flex>
        </Flex>
        <Flex>
          {isMobile && (
            <OFText textStyle="body2" color={textColor} marginTop={["9px", "13px"]}>
              {description}
            </OFText>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
